<div class="row text-center" *ngIf="show">
  <div class="col-12" [ngClass]="{primaria: cor !== 'secundaria', secundaria: cor === 'secundaria'}">
    <i class="fa-solid fa-ellipsis fa-beat-fade fa-8x"></i>
  </div>
</div>
